import React from "react";
import logo from "../../../../assets/images/logo_vertical.png";
// import { Container } from './styles';

const LogoVertical = () => <img src={logo} alt="Logo BovExo" />;

export default LogoVertical;
